import m from"./PhoneNumber.js";function i(e,r,f){if(r[e])return new m(e,r[e],f)}export{i as default};
